import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import { configHelper } from '@ilteducation/config';
import type { VideoTraceV1 } from '@ilteducation/history-tracker-types';

const HISTORY_TRACKER_BASE_URL = configHelper.getApiUrl('history-tracker');

const useHistoryStore = defineStore('history', () => {
  const watchHistories = ref<Record<string, VideoTraceV1[]>>({});
  const isLoading = ref(false);

  function getHistoryTracesByUserUid(userUid: string, limit = 30) {
    if (isLoading.value === true) return watchHistories;
    isLoading.value = true;

    return axios
      .get(`${HISTORY_TRACKER_BASE_URL}/traces?resourceType=video&owner=${userUid}&limit=${limit}`)
      .then((response) => response.data as VideoTraceV1[])
      .then((traces) => {
        watchHistories.value[userUid] = traces ?? [];
      })
      .finally(() => {
        isLoading.value = false;
      });
  }

  return { watchHistories, getHistoryTracesByUserUid, isLoading };
});

export default useHistoryStore;
